module.exports = __webpack_public_path__ + "img/jsoneditor-icons.256e3ab.svg";